import { Controller } from "@hotwired/stimulus";

// Marks the clicked mode tab as loading so the user sees an immediate
// indicator while Turbo fetches the new mode's frame. The state is cleared
// automatically when the frame swaps in fresh markup.
export default class extends Controller {
  static values = { frameId: String };

  declare frameIdValue: string;
  declare hasFrameIdValue: boolean;

  showLoading(event: Event) {
    const link = event.currentTarget as HTMLElement;
    if (!link.dataset.turboFrame) return;
    link.dataset.loading = "true";
  }

  // Swap-mode click: mirrors the header mode-pill-group behavior. The link's
  // href is the page URL; `data-frame-url` is the frame-only URL. Update the
  // address bar via replaceState and reassign the target frame's src so only
  // the playground content refetches — the surrounding page shell stays put.
  swap(event: MouseEvent) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    if (!this.hasFrameIdValue) return;

    const link = event.currentTarget as HTMLAnchorElement;
    const frameUrl = link.dataset.frameUrl;
    if (!frameUrl) return;

    const frame = document.getElementById(this.frameIdValue) as
      | (HTMLElement & { src: string })
      | null;
    if (!frame) return;

    event.preventDefault();
    link.dataset.loading = "true";
    history.replaceState({}, "", link.href);
    frame.src = frameUrl;
  }
}
